module.exports = __webpack_public_path__ + "img/img33.2af52f7b.png";